import {Shop} from '../types'

import noPhotoPic from '@/src/shared/assets/media/no-photo.png'
import {Image} from '@/src/shared/ui/image'

import * as UI from './tile.styled'

interface IProps {
  shop: Shop
  onSelect(shop: Shop): void
}

export const ShopTile = ({shop, onSelect}: IProps) => {
  return (
    <UI.Card>
      <UI.Image>
        {shop.properties?.city && <UI.CityShortName>{shop.properties.city}</UI.CityShortName>}
        {(shop.image && shop.image.type === 'image' && (
          <Image src={`${shop.image.src}`} width={0} height={0} sizes="100vw" alt={shop.title} />
        )) || (
          <Image src={noPhotoPic} width={0} height={0} sizes="100vw" alt={shop.title} style={{objectFit: 'contain'}} />
        )}
      </UI.Image>
      <UI.Content>
        <UI.ShopName>{shop.title}</UI.ShopName>
        <UI.ShopAddress>{shop.address}</UI.ShopAddress>
        <UI.ShopSchedule>{shop.work_schedule || ''}</UI.ShopSchedule>
        {shop.description && <UI.Description dangerouslySetInnerHTML={{__html: shop.description}} />}
        <UI.ShopPhone>{shop.phone}</UI.ShopPhone>
        <UI.ShopEmail>{shop.email}</UI.ShopEmail>
        <UI.SeeButton outlined primary onClick={() => onSelect(shop)}>
          Посмотреть на карте
        </UI.SeeButton>
      </UI.Content>
    </UI.Card>
  )
}
